export default __webpack_public_path__ + "static/media/sigmund-freud.31b24667.jpg";